<template>
  <div class="industry" >
    <el-divider content-position="left">会员权限管理</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpen">新增权限</el-button>
        <el-button size="small" type="primary" @click="memberLevelSetting">返回至客户列表</el-button>
        <a href="/setting_panel" style="margin-left: 10px;">
          <el-button type="primary" size="small">返回上一级</el-button>
        </a>
      </el-col>
    </el-row>
    <el-table :data="pageData" size="medium" style="width: 100%">
      <el-table-column label='id'>
        <template slot-scope="scope">
          {{scope.row.access_id}}
        </template>
      </el-table-column>
      <el-table-column label='权限名称'>
        <el-tooltip slot-scope="scope" :content="scope.row.access_name" placement="top">
          <span class="count_style" style="display: inherit; cursor: pointer">{{scope.row.access_name}}</span>
        </el-tooltip>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--    页码-->
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <!--    添加-->
    <el-drawer
      title="添加"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="30%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6"  class="m-label">权限名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请输入权限名称"
              :size="inputSize"
              v-model="addData.access_name"
              clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"  class="m-label">权限名称描述</el-col>
          <el-col :span="15">
            <el-input
              type="textarea"
              placeholder="请输入权限名称描述"
              :size="inputSize"
              v-model="addData.access_comment"
              clearable>
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAdd">保存</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 编辑-->
    <el-drawer
      title="编辑"
      :visible.sync="saveDrawer"
      :direction="direction"
      :before-close="handleSaveDrawerClose"
      size="30%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6"  class="m-label">权限名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请输入权限名称"
              :size="inputSize"
              v-model="saveData.access_name"
              clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"  class="m-label">权限名称描述</el-col>
          <el-col :span="15">
            <el-input
              type="textarea"
              placeholder="请输入权限名称描述"
              :size="inputSize"
              v-model="saveData.access_comment"
              clearable>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'ClientAccess',
  data () {
    return {

      option: [],
      inputSize: 'small',
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      drawer: false,
      saveDrawer: false,
      direction: 'rtl',
      addData: {
        access_name: '',
        access_comment: ''
      },
      saveData: {
        access_name: '',
        access_comment: '',
        access_id: null,
        index: null
      }
    }
  },
  computed: {
    pageData: {
      get: function () {
        return this.option.slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getData () {
      this.$axios.get('/api/client_access/list')
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.option = data.data
            this.pageOption.total = this.option.length
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
    },
    handleSaveDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {
        })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    handleAddOpen () {
      this.drawer = true
    },
    handleEdit (index, row) {
      this.saveData.access_name = row.access_name
      this.saveData.access_comment = row.access_comment
      this.saveData.access_id = row.access_id
      this.saveData.index = index
      this.saveDrawer = true
    },
    handleDelete (index, id) {
      this.handleDeleteSub(index, id)
    },
    handleDeleteSub (index, id) {
      this.$axios.get('/api/talkcate/delete/' + id)
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index
            this.option.splice(idx, 1)
            this.pageOption.total = this.saveData.length
            if (index === 0) this.prePage()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    prePage () {
      if (this.pageOption.currentPage === 1) return
      this.pageOption.currentPage = this.pageOption.currentPage - 1
    },
    handleAdd () {
      if (!this.addData.access_name) {
        this.$message.error('权限名称不能为空！')
        return
      }
      this.$axios.post('/api/client_access/create', {val: [this.addData.access_name, this.addData.access_comment]})
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.option.unshift(data.data)
            this.pageOption.total = this.option.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.drawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearAddData () {
      this.addData.access_name = ''
      this.addData.access_comment = ''
    },
    clearSaveData () {
      this.addData.access_name = ''
      this.addData.access_comment = ''
    },
    handleSave () {
      if (!this.saveData.access_name) {
        this.$message.error('权限名称不能为空！')
        return
      }
      this.$axios.post('/api/client_access/update/' + this.saveData.access_id, {val: [this.saveData.access_name, this.saveData.access_comment]})
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            let index = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + this.saveData.index
            this.option[index].access_name = this.saveData.access_name
            this.option[index].access_comment = this.saveData.access_comment
            this.$message.success(data.msg)
            this.clearSaveData()
            this.saveDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    memberLevelSetting () {
      this.$router.push({
        path: '/my_customers'
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .industry
    marginLeft()
  .mt-10
    margin-top: .2rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .industry >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .addCon
    padding: .2rem
    text-align: right

</style>



// WEBPACK FOOTER //
// src/pages/client_access/ClientAccess.vue